import React, { Component } from 'react';
import Stepper from '../common/StepperCommon';
import { getPredicateValue } from '../../helpers/util';
import Label from './label';
import { Icon } from 'antd';

export default class StepperModel extends Component {
  constructor(props){
    super(props)
    let format = {}
    if (this.props.cFormatData) {
      try {
        format = JSON.parse(this.props.cFormatData);
      } catch (e) { }
    }
    this.state = {
      className: props.className || 'stepper_model',
      format,
    }
  }

  componentDidMount(){
    if (this.props.model)
      this.props.model.addListener(this)
  }

  componentWillUnMount(){
    if(this.props.model)
      this.props.model.removeListener(this)
  }

  setListenerState(params){
    const { format } = this.state;
    let { iNumPoint } = params;
    if (format && format.decimal)
      iNumPoint = getPredicateValue(format.decimal);
    if (!cb.utils.isEmpty(iNumPoint))
      params.iNumPoint = iNumPoint;
    this.setState(params)
  }

  validate(val){
    debugger
  }

  onValueChange = (value) => {
    if(this.props.model)
      this.props.model.setValue(value)
  }

  getStepperControl = () => {
    let { bCanModify, value, iNumPoint, readOnly } = this.state;
    let disabled = readOnly ? true : false
    return (
      <Stepper 
        showType={bCanModify ? ( readOnly ? 'text' : 'input') : 'text'}
        disabled={disabled}
        onChange={this.onValueChange}
        decimal={iNumPoint || 0}
        value={value}
        />
    )
  }

  getControl = () => {
    let { readOnly, bIsNull, cShowCaption } = this.state;
    const title = !readOnly && bIsNull === false && cShowCaption ? <label><Icon type='star' />{cShowCaption}</label> : <label>{cShowCaption}</label>;
    let control = (cShowCaption ? <Label control={this.getStepperControl()} title={title} /> : this.getStepperControl());
    return control;
  }

  render() {
    let { className } = this.state;
    let control = this.getControl();
    return(
      <div className={className}>
        {control}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/stepper.jsx